// File: /src/shared/composables/useSpotsRemaining.ts
import { ref, computed } from 'vue';

/**
 * Composable for dynamic monthly spots calculation.
 * @param totalSpots Total spots available each month
 * @param minSpots Minimum spots to display (never zero)
 */
export function useSpotsRemaining(
  totalSpots: number,
  minSpots = 2
) {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // zero-based
  const day = now.getDate();

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const progress = day / daysInMonth;

  // Simple seeded random based on month and day for stable offsets
  const seed = year * 10000 + (month + 1) * 100 + day;
  function seededRandom(num: number) {
    const x = Math.sin(num) * 10000;
    return x - Math.floor(x);
  }

  // Determine a small offset (1–3) to avoid showing ``totalSpots`` exactly
  const offsetRange = 3;
  const offset = Math.floor(seededRandom(seed + 1) * offsetRange) + 1;

  // Compute number sold, ensuring a minimum leftover
  const sold = Math.min(
    Math.ceil(progress * (totalSpots - minSpots)) + offset,
    totalSpots - minSpots
  );

  // Reactive spots remaining
  const spotsRemaining = ref(
    Math.max(totalSpots - sold, minSpots)
  );

  return {
    spotsRemaining,
    maxSpots: totalSpots
  } as const;
}
